module.exports = __webpack_public_path__ + "frontend/images/pattern/pricing/white.jpg?84a912ba3dbe143ae4214eebea6b2074";